import React from 'react'
import Navbar from '../inc/Navbar';
import { Link } from "react-router-dom";
import ScrollToTop from "react-scroll-to-top";

import ReactPlayer from "react-player";
import vidavx2 from "../images/VIDA VX2.jpg";
import vida from "../images/Samir Sir with _vida Vx 2 Launch.jpg";
import Harleydavidson from "../images/Harley Davidson at G.P. PREMIA.jpeg";
import vidavx2launch from "../images/LAUNCH.jpg";


function Gpautokrishnagar() {
    return (
        <div>
            <Navbar />
            <br />
            <br />
            <br />
            <br />

            <ScrollToTop smooth top="100" color="Gray" />
            <div className='balajisareeblog'>
                <div className="album py-2">

                    <div className="container mt-4">
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item"><Link to="/" href="#">Home</Link></li>
                                <li className="breadcrumb-item"><Link to="/blog" href="#">All Blog</Link></li>
                                <li className="breadcrumb-item active" aria-current="page">G.P. Premia Krishnagar blog</li>
                            </ol>
                        </nav>
                    </div>
                </div>

                <br />


                <div className="album py-0">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-7">

                                <h1 className='linetext'><b style={{ color: "#736f6fff" }}> My Journey </b>with Hon'ble Samir Paul – A Relationship of Trust</h1>
                                <p className='websitedevelopment mb-2' style={{ color: "maroon" }}>One of the happiest moments in my professional life was my first meeting with Hon'ble Samir Paul. We first met at the office of G.P. Auto Centre, Krishnanagar. That very day Hon'ble Samir Paul Sir trusted me and gave me the important responsibility of website development of Pauls Hotel & Banquet. I successfully created the website with sincerity and perfect planning – <a href='https://www.paulshotel.com/' target="_blank" rel="noopener noreferrer">www.paulshotel.com</a> </p>


                                <p className='websitedevelopment' style={{ color: "maroon" }}><small>After this work, Hon'ble Samir Paul involved me in more projects. I also got the responsibility of complete website development of another of his projects Prothama Lifespace. Currently, I am handling the digital marketing of another of his businesses G.P. Premia Krishnanagar. G.P. Auto Centre, Krishnanagar
                                    6, R.N. Tagore Road, High Street, Nadia, West Bengal
                                    (Hero Authorized Dealer)

                                    With over 25 years of trusted customer service, G.P. Auto Centre has established itself as a reputable name in the automobile industry in Krishnanagar. I am privileged to handle the digital marketing responsibilities for G.P. Auto Centre, contributing to its continued growth and online presence.</small></p>
                            </div>
                            <div className="col-md-5">
                                <ReactPlayer className="mb-2" width="100%" height="100%" url="https://www.youtube.com/watch?v=rm--VE1xH54&t=4s" />


                            </div>
                        </div>
                        <br />
                        <h6 className='websitedevelopment mb-2' style={{ color: "maroon" }}>Prothama Lifespace is launching a landmark mega project in the heart of Krishnanagar, strategically located opposite the historic Krishnagar Rajbari. Prior to this, Prothama made headlines with Prothama Heights—an elegant 8-storey residential complex opposite Kotwali Thana. With its visionary developments, Prothama has earned a trusted reputation in Krishnanagar’s real estate landscape.
                            To know more, visit their official website: <a href='https://www.prothama.com/' target="_blank" rel="noopener noreferrer">www.prothama.com</a> </h6>

                        <h5 className='linetext websitedevelopment'><b>Hon'ble Samir Paul is a very compassionate and visionary entrepreneur. It is a real honor to work with a person and client like him. I am grateful and proud to be a part of such a professional relationship.</b></h5>

                        <br />
                        <h6><b>Team MR. INDIAN CODER</b></h6>
                    </div>
                </div>

                <br />

                <div className="album py-0">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-4 mt-3">
                                <img className="card-img-top" src={vidavx2} alt="vidavx2" />

                            </div>
                            <div className="col-md-4 mt-3">
                                <img className="card-img-top" src={vida} alt="gppremiakrishnaagar" />

                            </div>
                            <div className="col-md-4 mt-3">
                                <img className="card-img-top" src={vidavx2launch} alt="gppremiakrishnaagar" />

                            </div>
                            <div className="col-md-4 mt-3">
                                <img className="card-img-top" src={Harleydavidson} alt="Harleydavidson_Krishnagar" />

                            </div>
                        </div>
                    </div>
                </div>
                <br />
            </div>


        </div>
    )
}

export default Gpautokrishnagar